import { css } from 'emotion'

export const MessageActionListStyles = css``
